import React, { FC } from 'react';
import Star from 'crehana-icons/Star';
import { grayMain, yellowMain } from 'crehana-ui/styles/colors';

type StarRatingProps = {
  className?: string;
  score: number;
  size?: number;
  total?: number;
};

const StarsRating: FC<StarRatingProps> = ({
  className,
  score,
  size = 16,
  total,
}) => {
  const _score = Math.floor(score);
  const unfilledStars = total ? total - _score : 0;

  return (
    <ul className={`flex items-center flex-shrink-0 ${className}`}>
      {Array.from({ length: _score }).map((el, index) => (
        <li
          key={`filled-star-icon-${index}`}
          className="flex items-center"
          style={{ padding: 2 }}
        >
          <Star size={size} color={yellowMain} />
        </li>
      ))}
      {unfilledStars > 0 &&
        Array.from({ length: total - Math.floor(score) }).map((el, index) => (
          <li
            key={`star-icon-${index}`}
            className="flex items-center"
            style={{ padding: 2 }}
          >
            <Star size={size} color={grayMain} />
          </li>
        ))}
    </ul>
  );
};

export default StarsRating;
